module.exports = __webpack_public_path__ + "static/banana_error_404-1e6bf1a38d4234a58a0f6757f46614f3.png";